var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyBusinessProfile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.375 3H2.625C2.00368 3 1.5 3.50368 1.5 4.125V13.875C1.5 14.4963 2.00368 15 2.625 15H15.375C15.9963 15 16.5 14.4963 16.5 13.875V4.125C16.5 3.50368 15.9963 3 15.375 3Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 4.125C1.5 3.82663 1.61853 3.54048 1.8295 3.3295C2.04048 3.11853 2.32663 3 2.625 3H15.375C15.6734 3 15.9595 3.11853 16.1705 3.3295C16.3815 3.54048 16.5 3.82663 16.5 4.125V7.5H1.5V4.125Z",
    stroke: "white",
    strokeWidth: 1.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 5.25C3 4.83579 3.33579 4.5 3.75 4.5C4.16421 4.5 4.5 4.83579 4.5 5.25C4.5 5.66421 4.16421 6 3.75 6C3.33579 6 3 5.66421 3 5.25Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 5.25C5.25 4.83579 5.58579 4.5 6 4.5C6.41421 4.5 6.75 4.83579 6.75 5.25C6.75 5.66421 6.41421 6 6 6C5.58579 6 5.25 5.66421 5.25 5.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyBusinessProfile);
export default __webpack_public_path__ + "static/media/MyBusinessProfile.6f889816bbc3bb8405f380c88986937c.svg";
export { ForwardRef as ReactComponent };